import React from 'react';
var axios = require('axios');
var constants = require("../constants/constants");

export default class KamgarInformation extends React.Component {
    constructor(props) {
        super(props);
        let CompanyId = localStorage.getItem('CompanyId') || 1;
        this.state = {
            workerInfo: [],
            name: props.name,
            MukadamId: props.location.MukadamId,
            CompanyId: props.location.CompanyId,
        };
    }

    componentWillMount() {
        var user = JSON.parse(sessionStorage.getItem("User"));
        let currentComponent = this;
        axios.get(constants.config.HOST + constants.api.GET_KAMGAR_INFORMATION, {
            params: { TransportersId: user.TransportersId, CompanyId: localStorage.getItem('CompanyId') || 1, YearId: user.TargetYearId, MukadamId: this.props.location.MukadamId }
        }).then(function (response) {
            currentComponent.setState({ workerInfo: response.data })
            console.log(response.data)
        }).catch(function (error) {
            console.log(error);
        });
    }

    handleInputChangeFile(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.files[0];
        this.setState(state);
    }

    render() {
        return (
            <div class="pages">
                <div data-page="form" class="page no-toolbar no-navbar">
                    <div class="page-content">
                        <div class="navbarpages navbarpagesbg">
                            <div class="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                        </div>
                        <div id="pages_maincontent">
                            <h3 style={{ 'color': '#3700B3' }} > <b style={{ 'padding-left': '20px' }}>ऊस तोडणी कामगाराची माहिती</b></h3>
                            <div>
                                {
                                    (this.state.workerInfo != null || this.state.workerInfo != undefined) ?
                                        this.state.workerInfo.map(function (worker, index) {
                                            return (
                                                <tr>
                                                    <div style={{ padding: '13px 20px 20px 13px' }} className="card ">
                                                        <h4>   <b> कामगाराचे नाव : <b style={{ 'color': '#3700B3' }}> {worker.fullname}</b></b><br /> </h4>
                                                        <h4>   <b>  मोबाईल नंबर :<b style={{ 'color': '#3700B3' }}>  {worker.ContactNo}</b></b> </h4>
                                                    </div>
                                                </tr>
                                            )
                                        })
                                        : ''
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/component/KamgarInformation.jsx